import {  NgModule } from '@angular/core';
import { AcessoRoutingModule } from './acesso.routing.module';

import { 
  AcessoComponent
} from './index.component';
import { SharedModule } from '@smdapp/shared';
import { NgSharedModule } from '@smdapp/ng-shared/ng-shared.module'
import { CommonModule } from '@angular/common';

@NgModule({
  imports: [AcessoRoutingModule, NgSharedModule, SharedModule, CommonModule],
  declarations: [
  AcessoComponent
  ]
})
export class AcessoModule {}
